module.exports = {
  correct_answers: '%{answers} richtige Antwort | %{answers} richtige Antworten',
  challenging_questions: {
    failrate: '%{failrate}% lagen falsch',
    test_my_knowledge: 'Hättest du es gewusst?',
    answered_correctly: 'Du hast diese Frage richtig beantwortet',
    title: 'Schwerste Fragen der Woche',
  },
  win_percentage: '%{percentage}% gewonnen',
  answers_correct_percentage: '%{percentage}% richtig',
  rank: 'Rang',
  by_wins: 'nach Siegen',
  answers: 'Antworten',
  correct_answers_14_days: 'Richtige Antworten letzte 14 Tage',
  answers_by_category: 'Antworten nach Kategorie',
  wins: 'Siege',
}
